<template>
  <tr>
    <td class="w-full">{{ department.name | nullable }}</td>
    <td>
      <button class="edit-button" @click="$emit('edit', department.id)">
        <i class="fa fa-fw fa-pencil-square-o" />
      </button>
    </td>
    <td>
      <button class="delete-button" @click="$emit('delete', department.id)">
        <i class="fa fa-fw fa-minus-circle" />
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    department: {
      required: true,
      type: Object
    }
  }
}
</script>
